export const STORE_STORAGE_NAME = {
    setting: 'settings',
    tabSession: 'tabSession'
};